import { render, staticRenderFns } from "./CaptchaForm.vue?vue&type=template&id=6d9a4f45&scoped=true"
import script from "./CaptchaForm.vue?vue&type=script&lang=js"
export * from "./CaptchaForm.vue?vue&type=script&lang=js"
import style0 from "./CaptchaForm.vue?vue&type=style&index=0&id=6d9a4f45&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a4f45",
  null
  
)

export default component.exports